<template>
  <div>
    <div class="paotui-info">
      <div class="paotui-logo">
        <i class="iconfont icon-kuaidiyuan-xianxing logo"></i>
      </div>
      <div class="paotui-otherinfo">
        <div class="name">{{paotuiName}}</div>
        <div class="time">{{paotuiTime}}左右送达</div>
      </div>
    </div>
    <div class="comment">
      <p class="title">为本次服务打分</p>
      <cube-rate v-model="value"></cube-rate>
    </div>
    <div class="weui-flex">
      <div class="weui-flex__item item" :class="{'selected':tags.tag1}" @click="toggle(1, 2)">态度好</div>
      <div class="weui-flex__item item" :class="{'selected':tags.tag2}" @click="toggle(2, 1)">态度差</div>
      <div class="weui-flex__item item" :class="{'selected':tags.tag3}" @click="toggle(3, 4)">准时到达</div>
      <div class="weui-flex__item item" :class="{'selected':tags.tag4}" @click="toggle(4, 3)">超时到达</div>
    </div>

    <div class="weui-cells">
      <a class="weui-cell weui-cell_access" href="javascript:;" @click="reward(1)">
        <div class="weui-cell__bd ok">
          <p>我觉得服务还不错</p>
        </div>
        <div class="weui-cell__ft">额外赏TA 1元</div>
      </a>
      <a class="weui-cell weui-cell_access" href="javascript:;" @click="reward(2)">
        <div class="weui-cell__bd good">
          <p>我觉得服务非常好</p>
        </div>
        <div class="weui-cell__ft">额外赏TA 2元</div>
      </a>
      <a class="weui-cell weui-cell_access" href="javascript:;" @click="reward(3)">
        <div class="weui-cell__bd verygood">
          <p>我觉得服务棒棒的</p>
        </div>
        <div class="weui-cell__ft">额外赏TA 3元</div>
      </a>
      <div class="weui-cell weui-cell_vcode">
        <div class="weui-cell__hd">
          <label class="weui-label" style="width: 100%; color: #1aad19;">自定义赏金
          </label>
        </div>
        <div class="weui-cell__bd">
          <input class="weui-input" type="number" v-model="money" placeholder="额外赏TA？元" style="text-align: right;" />
        </div>
        <div class="weui-cell__ft" @click="reward(money)">
          <button class="weui-vcode-btn reward-bnt">
            <font style="padding-left: 1px;">打 赏</font>
          </button>
        </div>
      </div>
    </div>
    <div class="footer-item" @click="comment">
      <a href="javascript:;">提交评价</a>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";
const wx = require("weixin-js-sdk");

export default {
  data() {
    return {
      paotuiId: "",
      acceptOpenid: "",
      value: 0,
      paotuiName: "",
      paotuiTime: "",
      encodeToken: "",
      token: "",
      tags: {
        tag1: false,
        tag2: false,
        tag3: false,
        tag4: false
      },
      tagValues: [],
      rewardMoney: 0,
      money: ''
    };
  },
  created() {
    this.paotuiId = this.$route.params.id;
    this.acceptOpenid = this.$route.params.acceptOpenid;
    let paotuiNameEncode = this.$route.params.paotuiName;
    this.paotuiName = decodeURIComponent(paotuiNameEncode);
    let paotuiTimeEncode = this.$route.params.paotuiTime;
    this.paotuiTime = moment(decodeURIComponent(paotuiTimeEncode)).format(
      "YYYY-MM-DD HH:mm"
    );
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = ["chooseWXPay"];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    reward(money) {
      if(!money || money<0) {
        weui.alert("赏金必须>=0");
        return;
      }
      let that = this;
      axios
        .get("/api/paotuiOrder/reward/" + this.paotuiId + "/" + money)
        .then(response => {
          if (response.data.success) {
            let payConfig = response.data.data;
            payConfig.success = function(res) {
              that.rewardMoney += money * 100;
              that.money = '';
            };
            wx.chooseWXPay(payConfig);
          } else {
            weui.alert("获取支付签名失败");
          }
        })
        .catch(error => {
          weui.alert("获取支付签名失败");
        });
    },
    comment() {
      let that = this;
      if (this.value == 0) {
        weui.alert("请为本次跑腿打分，一颗星起步哦");
        return;
      } else if (
        !this.tags.tag1 &&
        !this.tags.tag2 &&
        !this.tags.tag3 &&
        !this.tags.tag4
      ) {
        weui.alert("请选择本次服务标签");
        return;
      } else {
        // 保存评论信息
        let params = {
          paotuiId: this.paotuiId,
          acceptOpenid: this.acceptOpenid,
          score: this.value,
          tags: this.tagValues,
          rewardMoney: this.rewardMoney
        };
        axios
          .put("/api/paotuiOrder/comment/update", params)
          .then(res => {
            if (res.data.success) {
              weui.toast("评论成功");
              this.$router.push("/robbingListCompleteOrCancel/1/complete/" + this.encodeToken);
            } else {
              weui.alert(res.data.message, function() {
                that.$router.push("/robbingListCompleteOrCancel/1/complete/" + that.encodeToken);
              });
            }
          })
          .catch(err => {
            weui.alert("提交评论失败");
          });
      }
    },
    toggle(pushNum, spliceNum) {
      if (!this.tags["tag" + pushNum]) {
        this.tagValues.push(pushNum);
        let spliceIndex = this.tagValues.findIndex(item => item == spliceNum);
        if (spliceIndex != -1) {
          this.tagValues.splice(spliceIndex, 1);
          this.tags["tag" + spliceNum] = false;
        }
      } else {
        let index = this.tagValues.findIndex(item => item == pushNum);
        this.tagValues.splice(index, 1);
      }
      this.tags["tag" + pushNum] = !this.tags["tag" + pushNum];
      this.tagValues = this.tagValues.sort(function(a, b) {
        return a - b;
      });
    }
  }
};
</script>

<style scoped>
.paotui-info {
  display: flex;
  border-bottom: 1px solid #eee;
}
.paotui-logo {
  flex: 1;
}
.logo {
  font-size: 60px;
  margin-left: 15px;
  color: #1aad19;
}
.paotui-otherinfo {
  flex: 5;
  margin-left: 15px;
  margin-top: 15px;
}
.name {
  font-size: 24px;
  color: #1aad19;
}
.time {
  font-size: 16px;
  color: #1aad19;
}
.comment {
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
}
.comment .title {
  margin-bottom: 10px;
}
.other-comment {
  margin-top: 30px;
  display: flex;
  align-items: center;
}
.weui-flex {
  margin: 30px 15px;
}
.item {
  text-align: center;
  border: 1px solid #eee;
  padding: 6px 8px;
  border-radius: 4px;
}
.item.selected {
  border-color: orangered;
  color: orangered;
}
.item:first-child {
  margin-right: 8px;
  font-size: 14px;
}
.item + .item {
  margin-right: 8px;
  font-size: 14px;
}
.weui-cell__bd.ok {
  color: lightseagreen;
}
.weui-cell__bd.good {
  color: gold;
}
.weui-cell__bd.verygood {
  color: orangered;
}
.reward-bnt {
  background-color: #1aad19;
  color: #fff;
}
.footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  margin-top: 15px;
  line-height: 50px;
  background-color: #1aad19;
}
.footer-item a {
  color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/Comment.vue